module.exports = __webpack_public_path__ + "src/assets/img/whats-new-domion.538b0b73.png";